function asValues (value) {
  const items = Array.isArray(value) ? value : [value]
  return [
    ...new Set(
      items
        .filter(item => item !== null && item !== undefined)
        .map(item => String(item).trim())
        .filter(Boolean)
    )
  ]
}

export function anomalyOpenClosed (value) {
  const normalized = String(value ?? '')
    .trim()
    .toLowerCase()
  if (normalized === 'open') return 'Open'
  if (normalized === 'closed') return 'Closed'
  return 'Unknown'
}

export const filterDefinitions = [
  {
    key: 'technique',
    label: 'Inspection technique',
    values: row => asValues(row.inspection_technique)
  },
  {
    key: 'failureMode',
    label: 'Failure mode',
    values: row => asValues(row.failure_mode)
  },
  {
    key: 'severity',
    label: 'Severity',
    values: row => asValues(row.anomaly_severity)
  },
  {
    key: 'openClosed',
    label: 'Open / closed',
    values: row => [anomalyOpenClosed(row.open_closed)]
  },
  {
    key: 'status',
    label: 'Record status',
    values: row => {
      const values = asValues(row.anomaly_status)
      return values.length ? values : ['Not recorded']
    }
  }
]

export function getSearchText (row) {
  return [
    row.anomaly_ref,
    row.anomaly_report_id,
    row.site_id,
    row.asset_id,
    row.rds_component,
    row.rds_description,
    row.rds_subsystem,
    row.inspection_technique,
    row.failure_mode,
    row.anomaly_severity,
    row.open_closed,
    row.anomaly_status
  ].join(' ')
}
